module.exports = __webpack_public_path__ + "static/media/Werewolf.783dc946.png";